<div [class]="class" [formGroup]="form" matAutocompleteOrigin #origin="matAutocompleteOrigin">
  <mat-form-field [class]="'border-round-sm ' + (readonly ? 'bg-bluegray-50' : 'bg-white')" [floatLabel]="(icon || hasCustomPrefix ? 'always' : 'auto')">
    <mat-label *ngIf="label" >{{label}}</mat-label>
    <input #myInput matInput [formControlName]="name" [placeholder]="placeholder" [type]="type" *ngIf="type !== 'number'; else numberInput" class="mt-1" [readonly]="readonly" [matAutocomplete]="auto" [matAutocompleteConnectedTo]="origin">
    <mat-autocomplete #auto="matAutocomplete">
      @if (autocompleteOptions) {
        @for (option of autocompleteOptions(); track option) {
          <mat-option [value]="autocompleteValueField ? option[autocompleteValueField] : option">{{option[autocompleteLabelField]}}</mat-option>
        }
      }
    </mat-autocomplete>
    <ng-template #numberInput>
      <input #myInput matInput [formControlName]="name"  (input)="checkNumberValue($event)" [placeholder]="placeholder" [type]="type" [min]="min" [max]="max" [step]="step" [style]="type==='number' ? 'text-align:center;' : ''" class="mt-1" (blur)="onBlur($event)">
    </ng-template>
    <mat-icon *ngIf="icon" matIconPrefix class="text-700 material-symbols-outlined">{{icon}}</mat-icon>
    <div *ngIf="hasCustomPrefix" matPrefix class="flex align-items-center mt-1">
      <div #refPrefix >
        <ng-content select="[prefix]"></ng-content>
      </div>
    </div>
    <div matSuffix class="flex px-1 align-items-center">
      <mat-icon *ngIf="clearable && isDirty" class="text-700 material-symbols-outlined cursor-pointer" (click)="clear()">cancel</mat-icon>
      <div #refSuffix>
        <ng-content select="[suffix]"></ng-content>
      </div>
    </div>
  </mat-form-field>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
